// react
import React, { Component, PropTypes } from "react"
//material-ui
import MUITextField from "material-ui/TextField"


class TextField extends Component {
    constructor(props) {
        super(props)

        this.state = {
            errorText: "",
            value: ""
        }

        this.handleChange = this.handleChange.bind(this)
    }

    componentWillMount() {
        if (this.props.mandatory === true) {
            if (this.props.value === "") {
                this.setState({ errorText: "This field is required" })
                if (this.props.onError) this.props.onError(true)
            }
        }
    }

    handleChange(e) {
        const value = e.target.value

        if (this.props.mandatory && value === "") {
            this.setState({
                errorText: "This field is required"
            })
            if (this.props.onError) this.props.onError(true)
        } else {
            this.setState({
                errorText: "",
                value
            })

            if (this.props.onError) this.props.onError(false)
            if (this.props.onChange) this.props.onChange(value)
        }
    }

    render() {
        const label = this.props.label + ((this.props.mandatory === true)?("*"):(""))

        return (
            <MUITextField
                autoFocus={ this.props.autoFocus }
                defaultValue={ this.props.value }
                floatingLabelText={ label || "" }
                errorText={ this.state.errorText }
                hintText={ this.props.hintText || "" }
                onChange={ this.handleChange }
                maxLength={ this.props.maxLength || 255 }
                rows={ this.props.rows }
                rowsMax={ this.props.rowsMax }
                multiLine={ this.props.multiLine }
                type={ this.props.type || "text" }
                fullWidth={ true }
                onKeyDown={ this.props.onKeyDown }
            />
        )
    }
}

TextField.propTypes = {
    autoFocus: PropTypes.bool,
    hintText: PropTypes.string,
    mandatory: PropTypes.bool,
    maxLength: PropTypes.number,
    multiLine: PropTypes.bool,
    label: PropTypes.string,
    rows: PropTypes.number,
    rowsMax: PropTypes.number,
    type: PropTypes.string,
    value: PropTypes.any,
    onChange: PropTypes.func,
    onError: PropTypes.func,
    onKeyDown: PropTypes.func
}

export default TextField


/** WEBPACK FOOTER **
 ** ./src/components/common/TextField/text-field.js
 **/